import React from 'react';
import { Tooltip } from 'antd';
import styles from './ToolButton.module.css';

/** 32px ghost icon button for the header's tool strip. */
const ToolButton = ({ title, onClick, children }) => (
    <Tooltip title={title} placement="bottom">
        <button type="button" className={styles.button} onClick={onClick} aria-label={title}>
            {children}
        </button>
    </Tooltip>
);

const HEX = /^#[0-9a-f]{6}$/i;

/**
 * A ToolButton whose whole face is a native colour picker. `value` is the
 * current colour, which the picker opens on when it is a hex value; the icon
 * itself is expected to carry the colour.
 */
export const ColorToolButton = ({ title, icon, value, onChange }) => (
    <ToolButton title={title}>
        {icon}
        <input
            type="color"
            className={styles.colorInput}
            aria-label={title}
            value={HEX.test(value || '') ? value : '#000000'}
            onChange={(e) => onChange(e.target.value)}
        />
    </ToolButton>
);

export default ToolButton;
